import React, { FC } from 'react';

interface Props {
  step: number;
}

const Steps: FC<Props> = ({ step: currentStep }) => {
  return (
    <div>
      <div className="flex items-center justify-center gap-2 md:gap-4">
        {[1, 2, 3, 4].map((step) => (
          <div key={step} className="flex items-center gap-2 md:gap-4">
            <div
              className={`flex h-8 w-8 md:h-10 md:w-10 items-center justify-center rounded-full text-sm md:text-base font-semibold transition-colors ${
                currentStep >= step ? 'bg-primary text-white' : 'bg-secondary text-black'
              }`}
            >
              {step}
            </div>
            {step < 4 && (
              <div
                className={`h-0.5 w-8 md:w-12 lg:w-16 transition-colors ${
                  currentStep > step ? 'bg-primary' : 'bg-secondary'
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Steps;
